export class StorageHelper {
	private static readonly tokenKey: string = "pr65v_2_usr_tk";
	private static readonly refreshTokenKey: string = "pr65v_2_usr_refresh_tk";
	private static readonly isOrgillVendorAccount: string = "isOrgillVendorAccount";

	static getToken(): string | null {
		return window.localStorage.getItem(this.tokenKey);
	}

	static getRefreshToken(): string | null {
		return window.localStorage.getItem(this.refreshTokenKey);
	}

	static getIsOrgillVendorAccount(): string | null {
		return window.localStorage.getItem(this.isOrgillVendorAccount);
	}

	static saveToken(token: string): void {
		window.localStorage[this.tokenKey] = token;
	}

	static saveRefreshToken(token: string): void {
		window.localStorage[this.refreshTokenKey] = token;
	}

	static saveIsOrgillVendorAccount(value: string): void {
		window.localStorage[this.isOrgillVendorAccount] = value;
	}

	static clearPrimaryInfo(): void {
		window.localStorage.removeItem(this.isOrgillVendorAccount);
	}

	static removeToken(): void {
		window.localStorage.removeItem(this.tokenKey);
	}

	static removeRefreshToken(): void {
		window.localStorage.removeItem(this.refreshTokenKey);
	}

	static killSession(): void {
		window.localStorage.clear();
	}
}

export default StorageHelper;
